/**
 * Product methods
 * -----------------------------------------------------------------------------
 *
 * @namespace product
 */

import axios from 'axios';
import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-fullscreen';
import zoomio from 'zoomio';
import enquire from 'enquire.js';
// import detectIt from 'detect-it';
import scrollMonitor from 'scrollmonitor';

var colorOptonIndex = 0;
var sizeOptionIndex = 0;
var finishOptionIndex = 0;
var technologyOptionIndex = 0;
var latchtypeOptionIndex = 0;
var rosettepairOptionIndex = 0;
var functionOptionIndex = 0;

var productMethods = {
  data: function data() {
    return {
      enableHistoryState: false,
      isProductToolbarMobileOpen: false,
      product: {},
      currentVariant: {},
      meta_description: '',
      meta_finish: '',
      meta_installation_manual: '',
      meta_warranty_document: '',
      meta_promotional_video: '',
      meta_model: '',
      meta_weight: ''
    };
  },


  methods: {

    /**
     * Product Single
     */
    _initProduct: function _initProduct() {
      var $container = $('[data-template="product"]');
      var $productTabs = $(app.selectors.productTabs);
      var $productToolbarMobile = $(app.selectors.productToolbarMobile);
      var $imageZoom = $(app.selectors.imageZoom);
      var productObj = app.selectors.productObj;

      // product tabs add active class to 1st child
      $productTabs.find('.nav-item').first().find('a').addClass('active');
      $productTabs.find('.tab-content .tab-pane').first().addClass('active');

      // stop parsing if we are not in the product template
      if (app.currentTemplate !== 'product') {
        return;
      }

      // set data
      app.product = JSON.parse($(productObj).html());
      var productData = JSON.parse($(productObj).html());
      app.product = productData.product;
      colorOptonIndex = productData.colorOptionIndex;
      sizeOptionIndex = productData.sizeOptionindex;
      finishOptionIndex = productData.finishOptionindex;
      technologyOptionIndex = productData.technologyOptionindex;
      latchtypeOptionIndex = productData.latchtypeOptionindex;
      rosettepairOptionIndex = productData.rosettepairOptionindex;
      functionOptionIndex = productData.functionOptionIndex;

      app.product.options_with_values = productData.options_with_values;

      // assign the product cart limit
      app.product.tags.forEach(function (tag) {
        if (tag.match('cart-limit')) {
          var cartLimit = tag.replace('cart-limit-', '');
          app.product.cart_limit = parseFloat(cartLimit);
          // console.log(app.product);
        }
      });

      app.enableHistoryState = $container.data('enable-history-state');
      app._getVariant();

      setTimeout(function () {
        // eslint-disable-next-line eqeqeq
        if ($.trim($('[data-selected_product]').text()) == 'N/A') {
          $('[data-selected_product]').closest('.selector-wrapper').hide();
        }
      }, 300);

      if ($('[data-handle="satin-nickel"]').length > 0) {
        $('[data-handle="satin-nickel"]').trigger('click');
      }

      // Recharge widget
      app._attachRechargeWidget(app.product.id);

      var productForm = document.querySelector('form[action="/cart/add"');
      var addToCartButton = document.querySelector('button[type="submit"][name="add"]');
      // console.log(productForm);
      Extend.buttons.render('#extend-offer', { referenceId: app.currentVariant.id });

      productForm.addEventListener('change', function () {
        var urlParams = new URLSearchParams(window.location.search);
        var variantId = urlParams.get('variant');

        // console.log('variantId');
        // console.log(variantId);

        Extend.setActiveProduct('#extend-offer', variantId);
      });

      addToCartButton.addEventListener('click', function (e) {
        e.preventDefault();
        var component = Extend.buttons.instance('#extend-offer');
        var plan = component.getPlanSelection();
        var product = component.getActiveProduct();
        var quantity = $(productForm).find('input[name="quantity"]').val();
        // var quantity = quantityEl && quantityEl.value;
        var urlParams = new URLSearchParams(window.location.search);
        var variantId = urlParams.get('variant');

        if (plan && product) {

          // console.log("plan:");
          // console.log(plan);
          // console.log("product: ");
          // console.log(product);

          ExtendShopify.addPlanToCart({ plan: plan, product: product, quantity: quantity }, function () {
            // console.log("done 22222");
            jQuery.getJSON("/cart.js", function (e) {
              // console.log('in product.js');
              // console.log(e);
              var t = e;
              t.items.forEach(function (e) {
                e.properties || (e.properties = []);
              }), app.cart = t;
              $('#' + variantId).find('.extend-simple-offer').hide();
            });
          });
          // if no warranty plan is selected, render the modal
        } else if (!plan && product) {
          Extend.modal.open({
            referenceId: app.currentVariant.id,
            onClose: function onClose(plan, product) {
              // if a warranty plan is selected, add it to the cart and refresh the cart
              if (plan && product) {
                ExtendShopify.addPlanToCart({ plan: plan, product: product, quantity: quantity }, function () {
                  // console.log("done 111111");
                  jQuery.getJSON("/cart.js", function (e) {
                    // console.log('in product.js');
                    // console.log(e);
                    var t = e;
                    t.items.forEach(function (e) {
                      e.properties || (e.properties = []);
                    }),
                    // console.log(t),
                    app.cart = t;
                    $('#' + variantId).find('.extend-simple-offer').hide();
                  });
                });
              }
            }
          });
        }

        // ExtendShopify.handleAddToCart('#extend-offer',{
        //       quantity,
        //     modal: true,
        //     done: function(){
        //       console.log("done 111111"),
        //       jQuery.getJSON("/cart.js", function (e) {
        //           console.log('in product.js');
        //           console.log(e);
        //           var t = e;
        //           t.items.forEach(function (e) {
        //               e.properties || (e.properties = []);
        //           }),
        //           console.log(t),
        //           (app.cart = t);
        //           $('.extend-simple-offer').hide();
        //       });
        //     }
        // })
      });

      function registerMobileToolbar() {
        var productFormPosition = $(app.selectors.productForm).position();
        var formWatcher = scrollMonitor.create($(app.selectors.productForm));
        var footerWatcher = scrollMonitor.create($('[data-footer-bottom]'));
        $productToolbarMobile.show();

        window.addEventListener('scroll', function () {
          var windowScrollY = window.scrollY;

          if (windowScrollY > productFormPosition.top) {
            formWatcher.exitViewport(function () {
              // console.log( 'I have left the viewport' )
              $productToolbarMobile.addClass('semi-opened');
            });

            formWatcher.enterViewport(function () {
              // console.log( 'I have entered the viewport' )
              $productToolbarMobile.removeClass('semi-opened fully-opened');
              if (app.isProductToolbarMobileOpen) {
                app.isProductToolbarMobileOpen = false;
              }
            });

            footerWatcher.exitViewport(function () {
              $productToolbarMobile.addClass('semi-opened');
            });

            footerWatcher.enterViewport(function () {
              $productToolbarMobile.removeClass('semi-opened fully-opened');
              if (app.isProductToolbarMobileOpen) {
                app.isProductToolbarMobileOpen = false;
              }
            });
          } else {
            $productToolbarMobile.removeClass('semi-opened fully-opened');
            if (app.isProductToolbarMobileOpen) {
              app.isProductToolbarMobileOpen = false;
            }
          }
        }); // add scroll event listener
      }

      // mobile product form - sticky toolbar
      enquire.register('screen and (min-width: 720px)', {
        setup: function setup() {
          registerMobileToolbar();
        },
        match: function match() {
          $productToolbarMobile.hide();

          $imageZoom.zoomio({
            fadeduration: 200
          });
        },
        unmatch: function unmatch() {
          registerMobileToolbar();
        }
      });
    },


    /**
     * Event when product option select or input changes
     *
     */
    _getVariant: function _getVariant(event) {
      var variant = app._getVariantFromOptions(event);
      // stop parsing if there is no variant info
      if (!variant) {
        app.currentVariant = {};
        // $('[data-default-variant-id] span').text('Unavailable');
        app.unavailable = true;
        return;
      }

      app.unavailable = false;
      // const attr = $('[data-default-variant-id]').attr('disabled');
      // if (typeof attr !== typeof undefined && attr !== false) {
      //   $('[data-default-variant-id] span').text('Soldout');
      // } else {
      //   $('[data-default-variant-id] span').text('Add to cart');
      // }

      var url = window.location.href;
      if (url.indexOf('?reviews') > -1) {
        // eslint-disable-next-line operator-assignment
        window.location.href = window.location.href + '#reviews';
      }

      // eslint-disable-next-line max-statements-per-line
      if (colorOptonIndex == 1) {
        app.selectedSwatchColor = variant.option1;
      } else if (colorOptonIndex == 2) {
        app.selectedSwatchColor = variant.option2;
      } else if (colorOptonIndex == 3) {
        app.selectedSwatchColor = variant.option3;
      }
      // eslint-disable-next-line max-statements-per-line
      if (sizeOptionIndex == 1) {
        app.selectedSwatchSize = variant.option1;
      } else if (sizeOptionIndex == 2) {
        app.selectedSwatchSize = variant.option2;
      } else if (sizeOptionIndex == 3) {
        app.selectedSwatchSize = variant.option3;
      }
      // eslint-disable-next-line max-statements-per-line
      if (finishOptionIndex == 1) {
        app.selectedSwatchFinish = variant.option1;
      } else if (finishOptionIndex == 2) {
        app.selectedSwatchFinish = variant.option2;
      } else if (finishOptionIndex == 3) {
        app.selectedSwatchFinish = variant.option3;
      }
      // eslint-disable-next-line max-statements-per-line
      if (technologyOptionIndex == 1) {
        app.selectedSwatchTechnology = variant.option1;
      } else if (technologyOptionIndex == 2) {
        app.selectedSwatchTechnology = variant.option2;
      } else if (technologyOptionIndex == 3) {
        app.selectedSwatchTechnology = variant.option3;
      }
      // eslint-disable-next-line max-statements-per-line
      if (latchtypeOptionIndex == 1) {
        app.selectedSwatchLatchType = variant.option1;
      } else if (latchtypeOptionIndex == 2) {
        app.selectedSwatchLatchType = variant.option2;
      } else if (latchtypeOptionIndex == 3) {
        app.selectedSwatchLatchType = variant.option3;
      }
      // eslint-disable-next-line max-statements-per-line
      if (rosettepairOptionIndex == 1) {
        app.selectedSwatchRosettePair = variant.option1;
      } else if (rosettepairOptionIndex == 2) {
        app.selectedSwatchRosettePair = variant.option2;
      } else if (rosettepairOptionIndex == 3) {
        app.selectedSwatchRosettePair = variant.option3;
      }
      // eslint-disable-next-line max-statements-per-line
      if (functionOptionIndex == 1) {
        app.selectedSwatchFunction = variant.option1;
      } else if (functionOptionIndex == 2) {
        app.selectedSwatchFunction = variant.option2;
      } else if (functionOptionIndex == 3) {
        app.selectedSwatchFunction = variant.option3;
      }

      app._updateImages(variant, event);
      app._checkWishlist(variant);

      if (app.isQuickshopModalOpen) {
        app.quickShop.currentVariant = variant;

        // ReCharge Integration for the quick shop
        // Update data needed for ReCharge when variant changes
        // get current variant metafields for subscriptions
        axios.get('/products/' + app.quickShop.product.handle + '?variant=' + variant.id + '&view=variant-metafields-subscriptions.json').then(function (response) {
          if (response.data.discount_variant_id) {
            var rechargeFunction = 'reChargeJS_' + app.quickShop.product.id;
            // assign
            app.quickShop.metafields.subscriptions = response.data;
            app.reChargeDiscountVariantId = response.data.discount_variant_id;
            // Initialize Recharge widget script (currently opened product)
            window[rechargeFunction]($);
            // console.log(app.reChargeDiscountVariantId);
          }
          return response;
        }).catch(function (error) {
          console.log(error);
          throw error;
        });
      } else if (app.currentTemplate === 'collection') {
        // collection
        var productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
        var product = app.collection.products.find(function (x) {
          return x.id === productId;
        });
        product.current_variant = variant;
      } else if (app.currentTemplate === 'product') {
        app.currentVariant = variant;
        if (app.enableHistoryState) {
          app._updateHistoryState(variant);
        }

        axios.get('/products/' + app.product.handle + '?variant=' + variant.id + '&view=variant-metafields-information.json').then(function (response) {
          // eslint-disable-next-line eqeqeq
          if (response.data.description != undefined) {
            // eslint-disable-next-line eqeqeq
            if ($.trim(response.data.description) != 'NaN' || $.trim($.parseHTML(response.data.description)[0].innerHTML) != ' ' || response.data.description.indexOf('<ul></ul>') == -1) {
              app.meta_description = response.data.description;
            } else {
              app.meta_description = false;
            }
            // console.log(app.meta_description);
          }
          // eslint-disable-next-line eqeqeq
          if (response.data.installation_manual != undefined) {
            // eslint-disable-next-line eqeqeq
            if ($.trim(response.data.installation_manual) != 'NaN') {
              app.meta_installation_manual = response.data.installation_manual;
            } else {
              app.meta_installation_manual = false;
            }
          }
          // eslint-disable-next-line eqeqeq
          if (response.data.warranty_document != undefined) {
            // eslint-disable-next-line eqeqeq
            if ($.trim(response.data.warranty_document) != 'NaN') {
              app.meta_warranty_document = response.data.warranty_document;
            } else {
              app.meta_warranty_document = false;
            }
          }
          // eslint-disable-next-line promise/always-return
          if (response.data.promotional_video != undefined) {
            // eslint-disable-next-line eqeqeq
            if ($.trim(response.data.promotional_video) != 'NaN') {
              // eslint-disable-next-line prefer-template
              $('.video-wrapper-1').html('<video width="635" height="355" loop controls><source src="' + response.data.promotional_video + '?rel=0&autoplay=false" type="video/mp4"></video>');
              app.meta_promotional_video = response.data.promotional_video + '?rel=0&autoplay=false';
            } else {
              app.meta_promotional_video = false;
            }
          }
        }).catch(function (error) {
          console.log(error);
          throw error;
        });

        axios.get('/products/' + app.product.handle + '?variant=' + variant.id + '&view=variant-metafields-specifications.json').then(function (response) {
          // eslint-disable-next-line eqeqeq
          if (response.data.finish != undefined) {
            // eslint-disable-next-line eqeqeq
            if ($.trim(response.data.finish) != 'NaN') {
              // eslint-disable-next-line eqeqeq
              if (response.data.finish.charAt(0) == ',') {
                var res = response.data.finish.substring(1, response.data.finish.length);
                app.meta_finish = res;
              } else {
                app.meta_finish = response.data.finish;
              }
            } else {
              app.meta_finish = false;
            }
          }
          // eslint-disable-next-line eqeqeq
          if (response.data.model != undefined) {
            // eslint-disable-next-line eqeqeq
            if ($.trim(response.data.model) != 'NaN') {
              app.meta_model = response.data.model;
            } else {
              app.meta_model = false;
            }
          }
          // eslint-disable-next-line eqeqeq
          // eslint-disable-next-line promise/always-return
          if (response.data.weight != undefined) {
            // eslint-disable-next-line eqeqeq
            if ($.trim(response.data.weight) != 'NaN') {
              app.meta_weight = response.data.weight;
            } else {
              app.meta_weight = false;
            }
          }
        }).catch(function (error) {
          console.log(error);
          throw error;
        });

        // ReCharge Integration for the product page
        // Update data needed for ReCharge when variant changes
        var discountVariantId = $('[data-variant-id="' + variant.id + '"]').attr('data-discount-variant-id');
        app.reChargeDiscountVariantId = discountVariantId;
      }
    },


    /**
     * Get the currently selected options from add-to-cart form.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function _getCurrentOptions(event) {
      var singleOptionSelector = app.selectors.singleOptionSelector;
      var currentOptions = [];
      var $container = void 0;

      if (app.isQuickshopModalOpen) {
        $container = $('[data-template="quickshop"]').find(app.selectors.productForm);
      } else {
        $container = event ? $(event.currentTarget).closest(app.selectors.productForm) : $(app.selectors.productForm);
      }

      $.map($(singleOptionSelector, $container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            currentOptions.push(currentOption);
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          currentOptions.push(currentOption);
        }
      });

      return currentOptions;
    },


    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function _getVariantFromOptions(event) {
      var selectedValues = app._getCurrentOptions(event);
      var variants = void 0;
      var found = false;
      if (app.isQuickshopModalOpen) {
        // quickshop
        variants = app.quickShop.product.variants;
      } else if (app.currentTemplate === 'collection') {
        // collection
        var productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
        var product = app.collection.products.find(function (x) {
          return x.id === productId;
        });
        variants = product.variants;
      } else if (app.currentTemplate === 'product') {
        // product
        variants = app.product.variants;
      } else if (app.currentTemplate === 'page') {
        // product-selector
        var _productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
        var _product = app.collection.products.find(function (x) {
          return x.id === _productId;
        });
        variants = _product.variants;
      }

      var selectedColor = $('[data-for-color] input:checked').val();
      var colorSoldout = [];
      // $('.size-swatch').hide();
      // eslint-disable-next-line eqeqeq
      // if (selectedColor != undefined) {
      //   $('.size-swatch').addClass('not-available');
      // }
      variants.forEach(function (variant) {
        var variant_title = variant.title;
        // eslint-disable-next-line eqeqeq
        // if (selectedColor != undefined) {
        //   // eslint-disable-next-line eqeqeq
        //   const soldout_title1 = variant_title.split('/')[0];
        //   const soldout_title2 = variant_title.split('/')[1];
        //   const soldout_title3 = variant_title.split('/')[2];
        //   // eslint-disable-next-line eqeqeq
        //   if ((selectedColor == variant.option1 && selectedColor != 'N/A') || (selectedColor == variant.option2 && selectedColor != 'N/A') || (selectedColor == variant.option3 && selectedColor != 'N/A')) {

        //     $('[data-for-size] input, [data-for-size1] input').each(function(index) {
        //       // eslint-disable-next-line eqeqeq
        //       if ($(this).val() == variant.option1 || $(this).val() == variant.option2 || $(this).val() == variant.option3) {
        //         console.log($(this).val());
        //         // $(this).closest('.size-swatch').show();
        //         $(this).closest('.size-swatch').removeClass('not-available');
        //       }
        //     });
        //   }
        // }

        var satisfied = true;
        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });
        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },


    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newUrl = void 0;

      var showReviewForm = app._getUrlParameter('showReviewForm');

      if (showReviewForm === '') {
        newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      } else {
        newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id + '&showReviewForm=' + showReviewForm;
      }

      window.history.replaceState({
        path: newUrl
      }, '', newUrl);
    },


    /**
     * Find variant image and scroll to this image
     * works for all product page templates
     * can be extended to update all images upon variant selection
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateImages: function _updateImages(variant, event) {
      var variantImage = variant.featured_image || {};
      var variantTitle = variant.title;
      var templateType = $('[data-product-template]').data('product-template');
      var $scrollTarget = $('[data-variant-title="' + variantTitle + '"]');
      var $container = void 0;
      var currentVariantImage = void 0;

      if (app.isQuickshopModalOpen) {
        $container = $('[data-template="quickshop"]');
        currentVariantImage = app.quickShop.currentVariant.featured_image || {};
      } else if (app.currentTemplate === 'collection') {
        $container = $(event.currentTarget).closest(app.selectors.productForm);
        var productId = $container.data('product-id');
        var product = app.collection.products.find(function (x) {
          return x.id === productId;
        });
        if (product.current_variant.featured_image) {
          currentVariantImage = product.current_variant.featured_image.src || {};
        } else {
          currentVariantImage = product.featured_image || {};
        }
      } else if (app.currentTemplate === 'product') {
        $container = $('[data-template="product"]');
        currentVariantImage = app.currentVariant.featured_image || {};
      }

      var $carousel = $container.find('[data-carousel-main]');

      // if (variantImage.src === currentVariantImage.src) {
      //   return;
      // }

      enquire.register('screen and (min-width: 720px)', {
        match: function match() {
          // For the 'minimal' product template
          // Scroll to variant image unless it's the first photo on load
          if (templateType === 'minimal' && !app.isQuickshopModalOpen && $scrollTarget[0]) {
            $('html, body').animate({
              scrollTop: $scrollTarget.offset().top
            }, 350);
          }
        }
      });

      if ($carousel.length > 0) {
        var flkty = Flickity.data($carousel[0]);

        if (typeof flkty === 'undefined') {
          return;
        }

        if (app.currentTemplate === 'product') {
          var val = variant.sku;
          var appendAllNav = '';
          var appendAllMain = '';
          var flkty_nav = new Flickity('[data-carousel-nav]'); // init flickity
          $('[data-thumbs]').each(function (index) {
            var imgName = $(this).data('variant-title');
            if (imgName.indexOf(val) > -1) {
              appendAllNav += $(this).html();
            }
          });
          // eslint-disable-next-line eqeqeq
          if ($.trim(appendAllNav) != '') {
            flkty_nav.destroy();
            $('[data-carousel-nav]').removeClass('flickity-enabled is-draggable').empty();
            $('[data-carousel-nav]').append(appendAllNav);
            var flkyNav = new Flickity('[data-carousel-nav]', {
              asNavFor: '.carousel-main',
              draggable: false,
              percentPosition: true,
              cellAlign: 'center',
              groupCells: '100%',
              pageDots: false,
              arrow: true
            });
          }
          var flkty_main = new Flickity('[data-carousel-main]'); // init flickity
          $('[data-thumbs-main]').each(function (index) {
            var imgName = $(this).data('variant-title');
            if (imgName.indexOf(val) > -1) {
              appendAllMain += $(this).html();
            }
          });
          // eslint-disable-next-line eqeqeq
          if ($.trim(appendAllMain) != '') {
            flkty_main.destroy();
            $('[data-carousel-main]').removeClass('flickity-enabled is-draggable').empty();
            $('[data-carousel-main]').append(appendAllMain);
            var flkyMain = new Flickity('[data-carousel-main]', {
              adaptiveHeight: true,
              contain: true,
              wrapAround: false,
              freeScroll: false,
              accessibility: true,
              setGallerySize: true,
              prevNextButtons: true,
              pageDots: false,
              arrow: true,
              lazyLoad: true,
              fullscreen: false,
              dragThreshold: 20
            });
          }
        }

        var cellElements = flkty.getCellElements();
        cellElements.forEach(function (element, index) {
          var imgAlt = $(element).data('variant-title');
          if (variantTitle.indexOf(imgAlt) !== -1) {
            flkty.selectCell(index, true, false); // value, isWrapped, isInstant
          }
        });
      }
    },


    /**
     * Mobile toolbar - product form - options
     */
    _toggleProductToolbarMobile: function _toggleProductToolbarMobile() {
      var $productToolbarMobile = $(app.selectors.productToolbarMobile);
      app.isProductToolbarMobileOpen = !app.isProductToolbarMobileOpen;
      $productToolbarMobile.toggleClass('fully-opened');
    }
  }
};

export default productMethods;